import { useEffect, useState } from "react";
import axios from "axios";
import "./Orderss.css";

const API_BASE = process.env.REACT_APP_API_BASE;

export default function OrderStatusPage() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const token = localStorage.getItem("access");

      const res = await axios.get(`${API_BASE}/orders/my/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setOrders(res.data.results || res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div>Loading orders...</div>;

  return (
    <div className="orders-container">
      <h2>My Orders</h2>

      {orders.length === 0 && <p>No orders yet</p>}

      {orders.map((order) => (
        <div key={order.id} className="order-card">
          {/* Product details */}
          {order.items && order.items.length > 0 && (
            <div className="order-product">
              <p>
                <strong>Product:</strong> {order.items[0].product.name}
              </p>
              <p>
                <strong>Quantity:</strong> {order.items[0].quantity}
              </p>
              <p>
                <strong>color:</strong> {order.items[0].color}
              </p>
            </div>
          )}
          <p>
            <strong>Status:</strong>
            <span className={`status ${order.status}`}>{order.status}</span>
          </p>

          <p>Total: {order.total_price}</p>

          <p>Paid: {order.paid_amount || 0}</p>

          <p>Remaining: {order.remaining_birr || 0}</p>

          <p>Date: {new Date(order.created_at).toLocaleString()}</p>
        </div>
      ))}
    </div>
  );
}
